import { Component, OnInit } from '@angular/core';
import { ViewChild } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { StepBreadcrumbComponent, StepBreadcrumbItem } from '../../shared/components/step-breadcrumb/step-breadcrumb.component';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { PoModalComponent, PoModalModule, PoPageModule, PoLoadingModule } from '@po-ui/ng-components';
import { DepartureHeaderComponent } from './departure-header/departure-header.component';
import { DepartureConferenceComponent } from './departure-conference/departure-conference.component';
import { ModalTerminalSelectComponent } from '../../modal-terminal-select/modal-terminal-select.component';

@Component({
  selector: 'app-departure',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    PoModalModule,
    PoPageModule,
    PoLoadingModule,
    DepartureHeaderComponent,
    DepartureConferenceComponent,
    ModalTerminalSelectComponent,
    StepBreadcrumbComponent
  ],
  templateUrl: './departure.component.html',
  styleUrl: './departure.component.css'
})
export class DepartureComponent implements OnInit {
  @ViewChild('modalTerminalSelect') modalTerminalSelect!: PoModalComponent;
  loading = false;
  showConference = false;
  conferenceParams: any = null;

  readonly breadcrumbs: StepBreadcrumbItem[] = [
    { label: 'Home', id: '/home' },
    { label: 'Conferência de Embarque', id: '/embarque' }
  ];

  orderCountStep = 1;

  constructor(
    private router: Router,
    private route: ActivatedRoute
  ) {}

  ngOnInit() {
    this.route.queryParams.subscribe(params => {
      // Se houver parâmetros de conferência, mostra o componente de conferência
      this.showConference = !!(params['branchCode'] && params['invoiceSequence']);
      if (this.showConference) {
        this.conferenceParams = params;
      }
    });
  }

  navigateBreadcrumb(event: { item: StepBreadcrumbItem; index: number }) {
    if (event.item.id) {
      this.router.navigate([event.item.id]);
    }
  }

  onLoading(event: boolean) {
    this.loading = event;
  }

  onTerminalModalOpen() {
    this.modalTerminalSelect.open();
  }
}
